
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiOwnShipControlZ as ObiOwnShipControlZElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-own-ship-control-z.js';
 
 
 

 
 export const ObiOwnShipControlZ = createComponent({
   react: React,
   tagName: 'obi-own-ship-control-z',
   elementClass: ObiOwnShipControlZElement,
   events: {
     
   }
  });
 
 